import { useContext } from 'react';
import { LanguageContext } from '@/contexts/LanguageContext';

export const useTranslation = () => {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }

  const { language, setLanguage, syncLanguageFromServer, languageOptions, translations, translationsOffline } = context;

  const t = (key: string, variables?: Record<string, string | number>): string => {
    const value = translations[key];
    if (typeof value !== 'string') {
      console.warn(`Translation missing for key: ${key} in language: ${language}`);
      return key;
    }
    if (!variables) return value;
    return value.replace(/\{\{(\w+)\}\}/g, (match, varName) => {
      return variables[varName]?.toString() ?? match;
    });
  };

  return {
    t,
    language,
    setLanguage,
    syncLanguageFromServer,
    languageOptions,
    translationsOffline,
  };
};
